export enum ValidMimeTypes {
    Jpeg = "image/jpeg",
    Tiff = "image/tiff",
}
